import createPlugin from "./createPlugin";

import ReviewsRenderer from "./Renderer/ReviewsRenderer";
import ReviewsForm from "./Form/ReviewsForm";

const productsPlugin = (settings) =>
    createPlugin({
        Renderer: ReviewsRenderer,
        Controls: ReviewsForm,
        ...settings,
    });

const products = productsPlugin();
export default products;

export { productsPlugin, ReviewsRenderer };
